ch-dropdown-render {
  display: contents;
}